import { Helmet } from 'react-helmet-async';

const SITE_NAME = 'webstore';
const SITE_URL = 'https://your-domain.com'; // Aruba домен
const DEFAULT_OG_IMAGE = `${SITE_URL}/og-default.jpg`; // положишь в public/

export default function SEO({ title, description, path = '/', image = DEFAULT_OG_IMAGE }) {
  const url = SITE_URL + path;
  const fullTitle = title ? `${title} | ${SITE_NAME}` : SITE_NAME;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      {description ? <meta name="description" content={description} /> : null}
      <link rel="canonical" href={url} />

      {/* Open Graph */}
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:title" content={fullTitle} />
      {description ? <meta property="og:description" content={description} /> : null}
      <meta property="og:url" content={url} />
      <meta property="og:image" content={image} />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      {description ? <meta name="twitter:description" content={description} /> : null}
      <meta name="twitter:image" content={image} />
    </Helmet>
  );
}
